<!-- <div class="page-header">
  <div class="header-content">
    <div class="scheme-info">
      <h2 class="scheme-name">{{ schemeName }}</h2>
      <div class="proposal-info">
        <span class="proposal-label">Proposal:</span>
        <span class="proposal-name">{{ proposalName }}</span>
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="d-flex justify-content-between gap-2 mb-3">
  <button
    *ngFor="let tab of tabList; let i = index"
    class="nav-tab btn flex-fill"
    [ngClass]="['tab-' + i, activeTabIndex === i ? 'active' : '']"
    (click)="onTabChange({ index: i })"
  >
    {{ tab.name }}
  </button>
</div> -->
<div class="flex gap-1 mb-3 bg-slate-100 p-1">
  <button *ngFor="let tab of tabList ; index as i"
    class="flex-1 px-3 py-2 font-bold transition-all duration-100 focus:outline-none hover:scale-105 hover:bg-blue-950 hover:text-white"
    [ngClass]="i+1 === step_details?.step_mapping?.phase_sequence ? 'bg-blue-950 text-white rounded transform scale-105 hover:scale-105' : 'bg-blue-50 text-blue-800  border-2 border-blue-600'">
    {{ tab.name }}
  </button>
</div>

<!-- <app-trans-header-steper *ngIf="topRender" (currentStepChange)="currentStepChange($event)"></app-trans-header-steper> -->
<app-trans-header-steper (currentStepChange)="currentStepChange($event)"></app-trans-header-steper>

<div class="mt-4">
  <div class="flex items-center justify-between mb-8 w-full">
    <div
      class="flex flex-nowrap items-center gap-1 bg-slate-200 p-1 rounded-xl border border-slate-300 shadow-sm overflow-x-auto">
      <ng-container *ngFor="let t of [
        { code: 'process', icon: 'pi-sitemap', txt: 'Process Flow', tip: 'View flow', action:'' },
        { code: 'comments', icon: 'pi-comments', txt: 'Comments', tip: 'View notes', action:'' },
        { code: 'report', icon: 'pi-file-pdf', txt: 'Reports', tip: 'Access reports', action:'getReportData' },
        { code: 'document', icon: 'pi-folder', txt: 'Documents', tip: 'Manage files', action:'getDocumentList' }
      ]">
        <button
          class="px-4 py-1 rounded-lg font-bold text-sm transition-all duration-300 flex items-center gap-2.5 whitespace-nowrap"
          [ngClass]="userGuide === t.code
            ? 'bg-slate-100 text-blue-700 shadow-md ring-1 ring-slate-300'
            : 'text-slate-700 hover:text-blue-700 hover:bg-slate-100/80'"
          (click)="userGuide = t.code; t.action && this[t.action]()" [pTooltip]="t.tip" tooltipPosition="top">

          <i class="pi text-base" [ngClass]="[t.icon, userGuide === t.code ? 'text-blue-700' : 'text-slate-500']"></i>
          <span>{{ t.txt }}</span>
        </button>
      </ng-container>
    </div>

  </div>
  <div class="mt-3">
    <div class="grid grid-cols-1">
      <div *ngIf="userGuide === 'process'">
        <div class="bg-white rounded-xs shadow " *ngIf="step_details">
          <ng-container [ngSwitch]="step_details?.code">
            <!-- <ng-container *ngSwitchCase="'T-IP'">
              <app-need-genration [id]="step_details.id" [step]="step_details"
                [getUrl]="'/make1/need-generation/?proposal_step='" [postUrl]="'/make1/need-generation/'"
                (generatePDFEmitter)="generatePDF($event)" [schemeType]="['makeII', 'makeIII']"
                (routeConfig)="showConfirm()" [isEditable]="isEditable"
                [stepDetails]="step_details"></app-need-genration>
            </ng-container> -->
            <ng-container *ngSwitchCase="'I-SP'">
              <app-need-genration [id]="step_details.id" [step]="step_details"
                [getUrl]="'/make1/need-generation/?proposal_step='" [postUrl]="'/make1/need-generation/'"
                (generatePDFEmitter)="generatePDF($event)" [schemeType]="'makeII'"
                (routeConfig)="showConfirm()" [isEditable]="isEditable"
                [stepDetails]="step_details"></app-need-genration>
            </ng-container>
            <ng-container *ngSwitchCase="'I-SPROP'">
              <app-need-genration [id]="step_details.id" [step]="step_details"
                [getUrl]="'/make1/need-generation/?proposal_step='" [postUrl]="'/make1/need-generation/'"
                (generatePDFEmitter)="generatePDF($event)" [schemeType]="'makeIII'"
                (routeConfig)="showConfirm()" [isEditable]="isEditable"
                [stepDetails]="step_details"></app-need-genration>
            </ng-container>
            <ng-container *ngSwitchCase="'makeI_02'">
              <app-need-genration [id]="step_details.id" [step]="step_details"
                [getUrl]="'/make1/need-generation/?proposal_step='" [postUrl]="'/make1/need-generation/'"
                (generatePDFEmitter)="generatePDF($event)" [schemeType]="'makeII'" (routeConfig)="showConfirm()"
                [isEditable]="isEditable" [stepDetails]="step_details" [type]="'approval'"></app-need-genration>
            </ng-container>
            <ng-container *ngSwitchCase="'M-RFI'">
              <app-rfi [id]="step_details.id" [step]="step_details" [getUrl]="'/make1/upload/rfi/?proposal_step='"
                [postUrl]="'/make1/upload/rfi/'" [schemeType]="'makeII'" (generatePDFEmitter)="generatePDF($event)"
                (routeConfig)="showConfirm()" [stepDetails]="step_details"></app-rfi>
            </ng-container>

            <!-- Project Sanction -->
            <ng-container *ngSwitchCase="'makeI_03'">
              <app-initiation-of-proposal [id]="step_details.id" [step]="step_details"
                [getUrl]="'/revenue/initiation-of-proposal/?proposal_step='"
                [postUrl]="'/revenue/initiation-of-proposal/'" [schemeType]="'makeII'"
                (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"></app-initiation-of-proposal>
            </ng-container>

            <ng-container *ngSwitchCase="'makeI_08'">
              <app-draft-soc [id]="step_details.id" [step]="step_details" [getUrl]="'/make1/draft-soc/?proposal_step='"
                [postUrl]="'/make1/draft-soc/'" [schemeType]="'makeII'" (generatePDFEmitter)="generatePDF($event)"
                (routeConfig)="showConfirm()" [stepDetails]="step_details"></app-draft-soc>
            </ng-container>

            <ng-container *ngSwitchCase="'PSO'">
              <app-sanction-order [id]="step_details.id" [step]="step_details" [getUrl]="'revenue/sanction-order/'"
                [schemeType]="'makeII'" [postUrl]="'revenue/sanction-order/'" (generatePDFEmitter)="generatePDF($event)"
                (routeConfig)="showConfirm()" [stepDetails]="step_details"></app-sanction-order>
            </ng-container>
            <ng-container *ngSwitchCase="'make3_852686'">
              <app-sanction-order [id]="step_details.id" [step]="step_details" [getUrl]="'revenue/sanction-order/'"
                [schemeType]="'makeII'" [postUrl]="'revenue/sanction-order/'" (generatePDFEmitter)="generatePDF($event)"
                (routeConfig)="showConfirm()" [stepDetails]="step_details"></app-sanction-order>
            </ng-container>



            <ng-container *ngSwitchCase="'R-AIP'">
              <app-aip [id]="step_details.id" [step]="step_details" [getUrl]="'/revenue/aip-details/?proposal_step='"
                [postUrl]="'/revenue/aip-details/'" (generatePDFEmitter)="generatePDF($event)"
                (routeConfig)="showConfirm()" [isEditable]="isEditable" [schemeType]="'makeII'"
                [stepDetails]="step_details"></app-aip>
            </ng-container>
            <ng-container>
              <app-vcns-approval *ngSwitchCase="'A-VCNS'" [id]="step_details.id" [step]="step_details"
                [getUrl]="'/make1/vcns/approval/?proposal_step='" [postUrl]="'/make1/vcns/approval/'"
                [schemeType]="'makeII'" (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()"
                [stepDetails]="step_details"></app-vcns-approval>
            </ng-container>
            <ng-container>
              <app-receipt-mom *ngSwitchCase="'R-MOM'" [id]="step_details.id" [step]="step_details"
                [getUrl]="'/make1/receipt/mom/?proposal_step='" [postUrl]="'/make1/receipt/mom/'"
                [schemeType]="'makeII'" (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()"
                [stepDetails]="step_details"></app-receipt-mom>
            </ng-container>
            <ng-container>
              <app-firm-response-submission *ngSwitchCase="'P_QR'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'makeII'" [stepDetails]="step_details" [proposalName]="proposalName" [format]="'upload'"
              [url]="'/make1/dms-file/vendor/'" (routeConfig)="showConfirm()"></app-firm-response-submission>
            </ng-container>
            <ng-container>
              <app-evaluation-of-eoi *ngSwitchCase="'I-EOI'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'makeII'" [stepDetails]="step_details" [proposalName]="proposalName" (routeConfig)="showConfirm()"></app-evaluation-of-eoi>
            </ng-container>
            <ng-container>
              <app-firm-response-submission *ngSwitchCase="'E-RDPR'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'makeII'" [stepDetails]="step_details" [proposalName]="proposalName" [format]="'evaluation'"
              [url]="'/make1/dms-file/vendor/'" (routeConfig)="showConfirm()"></app-firm-response-submission>
            </ng-container>
            <ng-container *ngSwitchCase="'NOM'">
              <app-nominations [proposalName]="proposalName" [isEditable]="isEditable"
                (generatePDFEmitter)="generatePDF($event)" [id]="step_details.id" [step]="step_details"
                [stepDetails]="step_details" [proposalId]="proposalId"></app-nominations>
            </ng-container>
            <ng-container *ngSwitchCase="'RE-VENDOR'">
              <!-- <app-vendor [id]="stapName.id" [step]="stapName" 
                                 (routeConfig)="showConfirm()" [isEditable]="isEditable" [schemeType]="'makeII'"
                                [stepDetails]="step_details"></app-vendor> -->
              <app-firm-response-submission [id]="step_details.id" [step]="step_details" [schemeType]="'makeII'"
                [stepDetails]="step_details" [proposalName]="proposalName" [format]="'upload'"
                [url]="'/make1/dms-file/vendor/'" (routeConfig)="showConfirm()"></app-firm-response-submission>
            </ng-container>

            <ng-container *ngSwitchCase="'PFT'">
              <app-constitute-committee [id]="step_details.id" [step]="step_details" [title]="'Constitute PFT'"
                [getUrl]="'revenue/constitute-committee/'" [postUrl]="'revenue/constitute-committee/'"
                (generatePDFEmitter)="generatePDF($event)" [isEditable]="isEditable" [stepDetails]="step_details"
                (routeConfig)="showConfirm()"></app-constitute-committee>
            </ng-container>

            <ng-container *ngSwitchCase="'makeI_06'">
              <app-feasibilty-study [id]="step_details.id" [step]="step_details" [isEditable]="isEditable"
                [stepDetails]="step_details" (generatePDFEmitter)="generatePDF($event)" [schemeType]="'makeII'"
                (routeConfig)="showConfirm()"></app-feasibilty-study>
            </ng-container>
            <ng-container *ngSwitchCase="'AC-AON'">
              <app-evaluation-of-eoi [id]="step_details.id" [step]="step_details" [schemeType]="'makeII'"
                [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-evaluation-of-eoi>
            </ng-container>


            <ng-container *ngSwitchCase="'C-EA'">
              <app-upload-comments-from-external-agencies [id]="step_details.id" (routeConfig)="showConfirm()"
                (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details" [schemeType]="'makeII'"
                [proposalName]="proposalName"></app-upload-comments-from-external-agencies>
            </ng-container>





            <ng-container *ngSwitchCase="'makeI_07'">
              <app-psqr [id]="step_details.id" [proposalName]="proposalName" [proposalId]="proposalId"
                (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()" [isEditable]="isEditable"
                [schemeType]="'makeII'" [stepDetails]="step_details"></app-psqr>
            </ng-container>

            <ng-container>
              <app-aon *ngSwitchCase="'R-AoN'" [id]="step_details.id" [step]="step_details"
                (routeConfig)="showConfirm()" [stepDetails]="step_details" [schemeType]="'makeII'"></app-aon>
            </ng-container>

            <ng-container *ngSwitchCase="'AON-SOC'">
              <app-aon-soc [id]="step_details.id" [stepDetails]="step_details"></app-aon-soc>
            </ng-container>

            <ng-container *ngSwitchCase="'R-EoI'">
              <app-eoi [id]="step_details.id" [step]="step_details" [schemeType]="'makeII'"
                [getUrl1]="'/make1/eol-details/?proposal_step='" [postUrl1]="'/make1/eol-details/'"
                (generatePDFEmitter)="generatePDF($event)" [masterData]="masterData" (routeConfig)="showConfirm()"
                [isEditable]="isEditable" [stepDetails]="step_details"></app-eoi>
            </ng-container>
            <ng-container *ngSwitchCase="'P-EOIPDD'">
              <app-eoi  [id]="step_details.id" [step]="step_details"
              [getUrl1]="'/make1/eol-details/?proposal_step='" [postUrl1]="'/make1/eol-details/'"
              (generatePDFEmitter)="generatePDF($event)" [masterData]="masterData" [stepDetails]="step_details"
              [schemeType]="'makeII'" (routeConfig)="showConfirm()"></app-eoi>
            </ng-container>
            <!-- <ng-container *ngSwitchCase="'R-UEOID'">
                            <app-upload-doc [id]="stapName.id" [step]="stapName" 
                                 (routeConfig)="showConfirm()" [isEditable]="isEditable" [stepDetails]="step_details"
                                [schemeType]="'makeII'"></app-upload-doc>
                        </ng-container> -->
            <!-- <ng-container *ngSwitchCase="'R-UEOID'">
              <app-firm-response-submission [id]="step_details.id" [step]="step_details" [schemeType]="'makeII'"
                [stepDetails]="step_details" [proposalName]="proposalName" [format]="'evaluation'"
                [url]="'/make1/dms-file/vendor/'" (routeConfig)="showConfirm()"></app-firm-response-submission>
            </ng-container> -->
            <ng-container>
              <app-evaluation-of-eoi *ngSwitchCase="'R-UEOID'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'makeII'" [stepDetails]="step_details" [proposalName]="proposalName" (routeConfig)="showConfirm()"></app-evaluation-of-eoi>
            </ng-container>

            <ng-container>
              <app-shortlisting-of-das *ngSwitchCase="'S-DAVCNS'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'makeII'" [stepDetails]="step_details" [proposalName]="proposalName" (routeConfig)="showConfirm()"></app-shortlisting-of-das>
            </ng-container>

            <ng-container>
              <app-evaluation-of-eoi *ngSwitchCase="'F-IPSO'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'makeII'" [stepDetails]="step_details" [proposalName]="proposalName" (routeConfig)="showConfirm()"></app-evaluation-of-eoi>
            </ng-container>

            <ng-container>
               <app-upload-drawings *ngSwitchCase="'Rev_011'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" (routeConfig)="showConfirm()" [schemeType]="'makeII'"></app-upload-drawings>
            </ng-container>

            <ng-container>
              <app-rfp-details *ngSwitchCase="'M-RFP'" [id]="step_details.id" [step]="step_details"
              [getUrl]="'/revenue/rfp-details/?proposal_step='" [postUrl]="'/revenue/rfp-details/'"
              [schemeType]="'makeII'" (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()"
              [stepDetails]="step_details"></app-rfp-details>
            </ng-container>

            <ng-container>
              <app-evaluation-of-eoi *ngSwitchCase="'I-LRFP'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'makeII'" [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-evaluation-of-eoi>
            </ng-container>

            <ng-container>
              <app-final-offer *ngSwitchCase="'R-FO'" [id]="step_details.id" [step]="step_details"
              [getUrl]="'revenue/final-offer/'" [postUrl]="'/revenue/final-offer/'"
              (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"
              [schemeType]="'makeII'" (routeConfig)="showConfirm()"></app-final-offer>
            </ng-container>

            <ng-container *ngSwitchCase="'P-EOI'">
              <app-pre-bid [id]="step_details?.id" [step]="step_details" [getUrl]="'revenue/pre-bid/'"
                [postUrl]="'revenue/pre-bid/'" (generatePDFEmitter)="generatePDF($event)" [isEditable]="isEditable"
                [stepDetails]="step_details" [schemeType]="'makeII'" (routeConfig)="showConfirm()">
              </app-pre-bid>
            </ng-container>
            <ng-container *ngSwitchCase="'makeI_13'">
              <app-shortlisting-vendors [id]="step_details.id" [step]="step_details" [schemeType]="'makeIII'"
                [isEditable]="isEditable" [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-shortlisting-vendors>
            </ng-container>

            <ng-container *ngSwitchCase="'R-PSO'">
              <app-sanction-order [id]="step_details.id" [step]="step_details" [getUrl]="'revenue/sanction-order/'"
                [postUrl]="'revenue/sanction-order/'" (generatePDFEmitter)="generatePDF($event)"
                [isEditable]="isEditable" [stepDetails]="step_details" [schemeType]="'makeIII'" (routeConfig)="showConfirm()"></app-sanction-order>
            </ng-container>

            <!-- Prototype & Eval -->
            <ng-container *ngSwitchCase="'idex_007'">
              <app-idex-prototype [proposalName]="proposalName" [proposalId]="proposalId" [step]="step_details"
                (generatePDFEmitter)="generatePDF($event)" [schemeType]="'makeII'" [stepDetails]="step_details"
                (routeConfig)="showConfirm()"></app-idex-prototype>
            </ng-container>
            <ng-container *ngSwitchCase="'I-SSCT'">
              <app-constitute-committee [id]="step_details.id" [step]="step_details" [title]="'Constitute SSCT'"
                [getUrl]="'revenue/constitute-committee/'" [postUrl]="'revenue/constitute-committee/'"
                (generatePDFEmitter)="generatePDF($event)" [isEditable]="isEditable"
                [stepDetails]="step_details"></app-constitute-committee>
            </ng-container>
            <ng-container *ngSwitchCase="'make1_009'">
              <app-ssct [proposalName]="proposalName" [isEditable]="isEditable"
                (generatePDFEmitter)="generatePDF($event)" [id]="step_details.id" [step]="step_details"
                (routeConfig)="showConfirm()" [stepDetails]="step_details" [proposalId]="proposalId"></app-ssct>
            </ng-container>
            <ng-container *ngSwitchCase="'makeI_29'">
              <app-staff-evaluation [proposalName]="proposalName" [isEditable]="isEditable"
                (generatePDFEmitter)="generatePDF($event)" [id]="step_details.id" [step]="step_details"
                (routeConfig)="showConfirm()" [stepDetails]="step_details"
                [proposalId]="proposalId"></app-staff-evaluation>
            </ng-container>
            <ng-container *ngSwitchCase="'Rev_013'">
              <app-idex-utrr (generatePDFEmitter)="generatePDF($event)" [step]="step_details" [data]="winner"
                [id]="step_details.id" [isEditable]="isEditable" [stepDetails]="step_details"
                [schemeType]="'makeIII'"></app-idex-utrr>
            </ng-container>
            <ng-container *ngSwitchCase="'I-RFP'">
              <app-idex-commercial-rfp [id]="step_details.id" [step]="step_details" [proposalName]="proposalName"
                (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()" [isEditable]="isEditable"
                [schemeType]="'makeII'" [stepDetails]="step_details"></app-idex-commercial-rfp>
            </ng-container>
            <ng-container *ngSwitchCase="'make1_001'">
              <app-idex-commercial-rfp [id]="step_details.id" [step]="step_details" [proposalName]="proposalName"
                (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()" [isEditable]="isEditable"
                [schemeType]="'makeII'" [stepDetails]="step_details"></app-idex-commercial-rfp>
            </ng-container>
            <!-- PSQR to SQR -->
            <ng-container *ngSwitchCase="'makeI_23'">
              <!-- <app-psqr [id]="stapName.id" [proposalName]="proposalName" [proposalId]="proposalId"
                                [isEditable]="isEditable"  
                                (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"></app-psqr> -->
              <app-psqr-to-sqr [id]="step_details.id" (generatePDFEmitter)="generatePDF($event)"
                (routeConfig)="showConfirm()" [isEditable]="isEditable" [stepDetails]="step_details"
                [schemeType]="'makeII'"></app-psqr-to-sqr>
            </ng-container>


            <ng-container *ngSwitchCase="'R-RFP-SOC'">
              <app-idex-rfp-soc (generatePDFEmitter)="generatePDF($event)" [proposalName]="proposalName"
                [masterData]="masterData" [step]="step_details" [id]="step_details.id" [isEditable]="isEditable"
                [stepDetails]="step_details" [schemeType]="'makeIII'"></app-idex-rfp-soc>
            </ng-container>
            <ng-container *ngSwitchCase="'tdf_005'">
              <app-constitute-committee [id]="step_details.id" [step]="step_details" [title]="'Constitute CNC'"
                [getUrl]="'revenue/constitute-committee/'" [postUrl]="'revenue/constitute-committee/'"
                (generatePDFEmitter)="generatePDF($event)" [isEditable]="isEditable"
                [stepDetails]="step_details"></app-constitute-committee>
            </ng-container>
            <ng-container *ngSwitchCase="'F-CNCR' ">
              <app-commercial-negocatition [id]="step_details.id" [isEditable]="isEditable" [step]="step_details"
                (routeConfig)="showConfirm()" [schemeType]="'makeII'" (generatePDFEmitter)="generatePDF($event)"
                [stepDetails]="step_details"></app-commercial-negocatition>
            </ng-container>
            <ng-container *ngSwitchCase="'M-SC' ">
              <app-sanction-order [id]="step_details.id" [step]="step_details" [getUrl]="'revenue/sanction-order/'"
                [schemeType]="'makeII'" [postUrl]="'revenue/sanction-order/'" (generatePDFEmitter)="generatePDF($event)"
                (routeConfig)="showConfirm()" [stepDetails]="step_details"></app-sanction-order>
            </ng-container>
            <ng-container *ngSwitchCase="'makeI_35' ">
              <app-final-offer [id]="step_details.id" [step]="step_details" [getUrl]="'revenue/final-offer/'"
                [postUrl]="'revenue/final-offer/'" (generatePDFEmitter)="generatePDF($event)" [isEditable]="isEditable"
                [stepDetails]="step_details" [schemeType]="'makeIII'" (routeConfig)="showConfirm()"></app-final-offer>
            </ng-container>


            <!-- Bulk production -->
            <ng-container *ngSwitchCase="'R-BM' ">
              <app-banchmark [id]="step_details.id" [step]="step_details" [isEditable]="isEditable"
                (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-banchmark>
            </ng-container>

            <ng-container *ngSwitchCase="'idex_19' ">
              <app-final-offer [id]="step_details.id" [step]="step_details" [getUrl]="'revenue/final-offer/'"
                [postUrl]="'revenue/final-offer/'" (generatePDFEmitter)="generatePDF($event)" [isEditable]="isEditable"
                [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-final-offer>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div *ngIf="userGuide === 'report'">
        <app-report [apiResponse]="apiResponse" [schemeType]="'makeII'"></app-report>
      </div>

      <div *ngIf="userGuide === 'document'" class="px-4 pt-2 pb-8">
        <div class="border border-blue-200 rounded-xl shadow bg-white">
          <!-- Header Section -->
          <div
            class="flex flex-col md:flex-row md:justify-between md:items-center bg-gradient-to-r from-blue-700 to-blue-500 text-white px-5 py-2 rounded-t-xl">
            <div class="flex items-center gap-3 mb-4 md:mb-0">
              <i class="pi pi-folder-open text-3xl"></i>
              <span class="text-2xl font-bold tracking-tight drop-shadow">Document Management</span>
            </div>
            <div class="flex flex-col md:flex-row md:items-center gap-3">
              <button
                class="flex items-center gap-2 bg-white/20 hover:bg-white/40 text-white border border-white/30 px-4 py-1 rounded-lg shadow-sm transition-colors focus:outline-none"
                (click)="documentTable.clear()">
                <i class="pi pi-filter-slash"></i>
                <span class="font-medium">Clear Filters</span>
              </button>
              <div class="flex items-center bg-white/90 rounded-lg px-3 py-1 min-w-[260px] shadow-inner">
                <i class="pi pi-search text-gray-400 text-xs mr-2"></i>
                <input pInputText type="text"
                  class="border-0 outline-none bg-transparent flex-1 text-gray-700 placeholder-gray-400 px-0 py-2"
                  placeholder="Search documents..." [(ngModel)]="searchText"
                  (keyup.enter)="documentTable.filterGlobal(searchText, 'contains')" />
              </div>
            </div>
          </div>

          <div class="p-2">
            <app-dmp [isEdit]="role_id === '21'" [proposalId]="proposalId"></app-dmp>

          </div>

          <!-- Document Table Section -->
          <ng-container *ngIf="documentList?.length; else noDocuments">
            <div class="bg-gradient-to-b from-amber-50 via-white to-amber-100 rounded-b-xl overflow-x-auto">
              <p-table #documentTable [value]="documentList" [paginator]="documentList.length > 10" [rows]="10"
                selectionMode="single" styleClass="p-datatable-striped"
                [globalFilterFields]="['name', 'type_document', 'description']">
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="name" class="bg-blue-50">
                      <div class="flex items-center justify-between">
                        <span class="flex items-center gap-2  font-semibold"><i class="pi pi-file"></i>Document
                          Name</span>
                        <div class="flex items-center gap-1">
                          <p-sortIcon field="name"></p-sortIcon>
                          <p-columnFilter class="text-gray-800" type="text" field="name"
                            display="menu"></p-columnFilter>
                        </div>
                      </div>
                    </th>
                    <th pSortableColumn="description" class="bg-blue-50 max-w-xs">
                      <div class="flex items-center justify-between">
                        <span class="flex items-center gap-2  font-semibold"><i
                            class="pi pi-align-left"></i>Description</span>
                        <div class="flex items-center gap-1">
                          <p-sortIcon field="description"></p-sortIcon>
                          <p-columnFilter class="text-gray-800" type="text" field="description"
                            display="menu"></p-columnFilter>
                        </div>
                      </div>
                    </th>
                    <th pSortableColumn="type_document" class="bg-blue-50">
                      <div class="flex items-center justify-between">
                        <span class="flex items-center gap-2  font-semibold"><i class="pi pi-tag"></i>Type</span>
                        <div class="flex items-center gap-1">
                          <p-sortIcon field="type_document"></p-sortIcon>
                          <p-columnFilter class="text-gray-800" type="text" field="type_document"
                            display="menu"></p-columnFilter>
                        </div>
                      </div>
                    </th>
                    <th class="bg-blue-50">
                      <div class="flex items-center  font-semibold"><i class="pi pi-calendar"></i><span
                          class="ml-2">Uploaded At</span></div>
                    </th>
                    <th class="bg-blue-50 text-center"><span class=" font-semibold">Action</span></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                  <tr [pSelectableRow]="item" class="hover:bg-blue-100/40 transition-colors group">
                    <td class="py-3 px-2">
                      <div class="flex items-center gap-2">
                        <i class="pi pi-file text-blue-500 opacity-70 text-base"></i>
                        <span class="font-medium text-gray-900 group-hover:text-blue-700 transition-all cursor-pointer"
                          [pTooltip]="item?.name" tooltipPosition="top">
                          {{ item?.name }}
                        </span>
                      </div>
                    </td>
                    <td class="py-3 px-2 max-w-xs">
                      <span class="text-gray-700" [pTooltip]="item?.description" tooltipPosition="right">
                        {{ (item?.description?.length || 0) > 60 ? (item?.description | slice: 0 : 60) + '…' :
                        item?.description }}
                      </span>
                    </td>
                    <td class="py-3 px-2">
                      <span
                        class="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold bg-amber-100 text-amber-700 border border-amber-300 shadow-sm uppercase tracking-wide">
                        {{ item?.type_document || '--' }}
                      </span>
                    </td>
                    <td class="py-3 px-2 text-gray-600">
                      <span class="inline-flex items-center gap-2 text-xs">
                        <i class="pi pi-clock text-amber-400"></i>
                        {{ item?.uploaded_at | date: 'dd-MM-yyyy hh:mm a' }}
                      </span>
                    </td>
                    <td class="py-3 px-2">
                      <div class="flex gap-2 justify-center items-center">
                        <a class="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-700 hover:to-blue-900 text-white shadow-lg hover:scale-105 transition-transform"
                          [href]="baseUrl + (item?.file || '')" target="_blank" rel="noopener"
                          pTooltip="Open document in new tab" tooltipPosition="left">
                          <i class="pi pi-eye"></i>
                        </a>
                        <!-- Download button -->
                        <a *ngIf="item?.file" [href]="baseUrl + (item?.file || '')" [attr.download]="item?.name"
                          class="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-gradient-to-r from-green-400 to-green-600 hover:from-green-600 hover:to-green-800 text-white shadow-lg hover:scale-105 transition-transform"
                          pTooltip="Download document" tooltipPosition="top">
                          <i class="pi pi-download"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="5" class="text-center py-16">
                      <div class="flex flex-col items-center text-sky-300 animate-fadeIn">
                        <i class="pi pi-search text-5xl mb-4"></i>
                        <p class="text-lg font-semibold mb-1">No matching documents found.</p>
                        <p class="text-sm text-gray-400">Try adjusting your filters or search terms.</p>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </ng-container>

          <!-- Empty State -->
          <ng-template #noDocuments>
            <div
              class="flex flex-col items-center justify-center py-20 text-gray-400 bg-slate-50 mx-6 mt-6 rounded-lg shadow-inner border-2 border-dashed border-blue-200 animate-fadeIn">
              <i class="pi pi-folder-open text-[5rem] mb-6 animate-bounce opacity-60"></i>
              <p class="text-xl font-bold mb-2 tracking-tight">No documents uploaded yet.</p>
              <p class="text-base text-gray-500 mb-2">Get started by uploading your first document.</p>
              <div class="flex gap-2">
                <span
                  class="inline-flex items-center rounded px-3 py-1 bg-blue-100 text-blue-700 text-xs font-normal shadow-sm">
                  <i class="pi pi-info-circle mr-2"></i> Only authorized users can upload.
                </span>
              </div>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- Comments -->
      <div *ngIf="userGuide === 'comments'" class="lg:col-span-1">
        <div class="bg-white rounded shadow p-3 sticky top-4">
          <app-commenting-seet [id]="step_details.id" [stepDetails]="step_details"></app-commenting-seet>
        </div>
      </div>





    </div>
  </div>
</div>


<p-toast position="center" key="confirm" [baseZIndex]="9999">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-col w-full p-1">
      <div class="flex items-center gap-3 mb-4 bg-blue-50 p-3 rounded-xl border border-blue-100">
        <div class="w-10 h-10 bg-blue-600 text-white rounded-lg flex items-center justify-center shadow-lg">
          <i class="pi pi-send"></i>
        </div>
        <div>
          <h4 class="text-sm font-black text-blue-900 uppercase tracking-tighter">Action Required</h4>
          <p class="text-[10px] text-blue-700 font-medium">Step: {{ step_details?.name }}</p>
        </div>
      </div>

      <textarea
        class="w-full min-h-[60px] rounded-md border border-slate-300 p-2 mb-3 text-xs font-medium text-slate-700 resize-y focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        placeholder="Add a comment or remarks for this action (optional)..." [(ngModel)]="comment"></textarea>

      <div class="flex flex-col gap-2">
        <button (click)="submitProposal(2)"
          class="w-full py-3 bg-blue-950 hover:bg-slate-900 text-white rounded-xl shadow-lg transition-all flex items-center justify-center gap-2 active:scale-95">
          <i class="pi pi-check-circle"></i>
          <span class="text-xs font-bold uppercase">Submit & Forward</span>
        </button>

        <div class="grid grid-cols-2 gap-2 mt-1">
          <button (click)="trigarFromChild()"
            class="py-2.5 bg-white border border-slate-200 hover:border-blue-300 text-slate-700 rounded-xl text-[10px] font-bold uppercase transition-all flex items-center justify-center gap-2">
            <i class="pi pi-cog"></i> Route Config
          </button>
          <button (click)="submitProposal(1)"
            class="py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-[10px] font-bold uppercase transition-all flex items-center justify-center gap-2">
            <i class="pi pi-save"></i> Save Draft
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>